module.exports = __webpack_public_path__ + "img/SEO_1200x630.a4eae806.jpg";